import { TabItem } from '../models';
import { DROPDOWN_OPERATORS } from '../mocks/data';

export const TAB_ITEMS: TabItem<string>[] = [
  {
    menuIcon: {
      type: 'icon',
      value: 'pi pi-align-right',
      prime: true,
      size: 'medium',
    },
    contentTemplate: null,
  },
  {
    menuIcon: { type: 'icon', value: 'gem', prime: false, size: 'xl' },
    contentTemplate: null,
  },
];

export const SEGMENT_RADIO_BUTTONS = [
  { label: 'Driver completes previous segment ', value: 'driver' },
  { label: 'Conditional', value: 'conditional' },
];

export const SEGMENT_OPTION_STATUS = [
  { name: 'Completed', code: 'C' },
  { name: 'In Progress', code: 'I' },
  { name: 'Failed', code: 'F' },
];

export const SET_CONDITIONS = {
  optionsSelectButtonSelected: 'and',
  optionsSelectButtonTopSelected: '',
  optionsSelectButtonTop: [
    { label: 'Simple', value: 'simple' },
    { label: 'Combined (AND, OR)', value: 'combined' },
  ],
  optionsSelectButton: [
    { label: 'AND', value: 'and' },
    { label: 'OR', value: 'or' },
  ],
  descriptionSelectButton: '',
  treeSelectOptionsIf: [],
  treeSelectOptionsThen: [],
  operators: DROPDOWN_OPERATORS,
};

export const OPTIONS_JSON = [
  { label: 'Json Value', value: 'json' },
  { label: 'Workflow Value', value: 'workflow' },
];
